window.createCookieWithSameSiteNone = function (name, value, days) {
    window.createCookieWithMillisTimeout(name, value, days && days * 24 * 60 * 60 * 1000, 'None');
};

window.createCookie = function (name, value, days) {
    window.createCookieWithMillisTimeout(name, value, days && days * 24 * 60 * 60 * 1000);
};

window.createCookieWithMillisTimeout = function (name, value, millis, sameSite) {
    let expires = '';
    if (millis && !isNaN(millis)) {
        const date = new Date();
        expires = '; expires=';
        date.setTime(date.getTime() + millis);
        expires = '; expires=' + date.toGMTString();
    }
    const sameSiteValues = ['strict', 'lax', 'none'];
    if (typeof sameSite === 'string' && sameSiteValues.includes(sameSite.toLowerCase())) {
        expires += '; SameSite=' + sameSite;
    }
    let domain = '';
    if (window.location.host.indexOf('donorschoose.org') !== -1) {
        domain = '; domain=donorschoose.org';
    }
    document.cookie = name + '=' + value + expires + ';secure; path=/' + domain;
};

window.readCookie = function (name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            let cookieString = c.substring(nameEQ.length, c.length);
            if (cookieString.charAt(0) === '"' && cookieString.charAt(cookieString.length - 1) === '"') {
                cookieString = cookieString.substring(1, cookieString.length - 1);
            }
            return cookieString;
        }
    }
    return null;
};

window.findCookie = function (namePatternString) {
    const ca = document.cookie.split(';');
    const patt = new RegExp(namePatternString);
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        c = c.split('=')[0];
        if (patt.test(c)) {
            return c;
        }
    }
    return null;
};

window.isNonBlankCookie = function (name) {
    const cookie = readCookie(name);
    return (cookie != null && cookie != '');
};

window.eraseCookie = function (name) {
    window.createCookie(name, '', -1);
};
